import { apiRequest } from "api";
import { BASE_URL } from "constants/routes";

export const handleEmailNotification = async (callback) => {
  try {
    const req = EmailNotificationUrl;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...callback}),
    };
    const result = await apiRequest(req, options);
    return result;
  } catch (err) {
    console.log(err);
  }
};

export const sendSMSInvite = async (smsParams) => {
  try{
    const req = SMSNotificationUrl;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({...smsParams}),
    };
    const result = await apiRequest(req, options);
    return result;
  } catch (err) {
    console.log(err);
  }
}
export const handleEmailBulkNotification = async (callback) => {
  try {
    const req = EmailBulkNotificationUrl;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...callback}),
    };
    const result = await apiRequest(req, options);
    // console.log("🚀 ~ file: callbacks.js:50 ~ handleEmailBulkNotification ~ result:", result)
    return result;
  } catch (err) {
    console.log(err);
  }
};

export const triggerSMSInvite = async (callback) => {
  try {
    const req = triggerSMSInvitation;
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ ...callback}),
    };
    const result = await apiRequest(req, options);
    return result;
  } catch (err) {
    console.log(err);
  }
};



const EmailNotificationUrl = `${BASE_URL}/workflow/sendNotification`;
const SMSNotificationUrl = `${BASE_URL}/workflow/sendSMSInvite`;
const EmailBulkNotificationUrl= `${BASE_URL}/workflow/sendBulkInvitation`
const triggerSMSInvitation = `${BASE_URL}/workflow/triggerSMSInvite`

